var manufacturers = {
    init:function(){
        var manufacturers_categories_carousel = $('.media-kit.media-kit-manufacturers .categories .categories-grid .categories-grid-carousel').slick({
            dots: false,
            arrows:false,
            nav:false,
            infinite: false,
            speed: 300,
            slidesToShow: 4,
            slidesToScroll: 1,
            swipeToSlide:true,
            responsive: [
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: false
                    }
                },
                {
                    breakpoint: 980,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 650,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });

        $('.media-kit.media-kit-manufacturers .categories .categories-grid .left').click(function(){
            manufacturers_categories_carousel.slick('slickPrev');
            return false;
        });
        $('.media-kit.media-kit-manufacturers .categories .categories-grid  .right').click(function(){
            manufacturers_categories_carousel.slick('slickNext');
            return false;
        });
    }
};


var UploadMedia = {

    init : function(target){

        var $this = this;


        $('#'+target).closest('.modal').one('shown.bs.modal',function(){

            var uploader = new plupload.Uploader({
                runtimes        : 'html5,flash,silverlight,browserplus',
                browse_button   : target + '-pickfiles',
                container       : target + '-container',
                drop_element    : target + '-dropzone',
                url             : UPLOAD_URL,
                headers:{
                    'X-CSRF-TOKEN':$('meta[name="csrf-token"]').attr('content')
                },
                multipart_params: {
                    'key': 'tmp/'+ USER_ID +'/${filename}',  
                    'Filename': '${filename}', 
                    'success_action_status':'201',
                    'acl': 'public-read',
                    "Content-Type": "image/*",
                    'AWSAccessKeyId' : S3_ACCESS_KEY,
                    'policy': S3_POLICY,
                    'signature': S3_SIGNATURE
                },
                filters : {
                    max_file_size : '3mb',
                    mime_types: [
                        {title : "Images", extensions : "jpg,jpeg,png"}
                    ]
                }
            });

            $('#'+target + '-uploadfiles').click(function(e) {
                uploader.start();
                e.preventDefault();
            });

            uploader.init();

            uploader.bind('FilesAdded', function(up, files) {

                $.each(files, function(i, file) {
                    var markup = '  <div id="' + file.id + '" style="position:relative;height:70px;background: #00000047;padding: 10px;vertical-align: middle;    display: block;    margin: 2px 0 2px 0;"><p style="text-overflow: ellipsis;overflow: hidden;">'+file.name+'<br/>' + plupload.formatSize(file.size) + '</p>\
                                    <div class="progress progress-small" style="display:none;height:6px;">\
                                        <div class="progress-bar progress-bar-danger" style="    background-color: rgb(34, 137, 233);width: 0%;"></div>\
                                    </div>';

                    $('#'+target + '-uploaded-files').append(markup);
                });
                up.refresh();

                uploader.start();
            });

            uploader.bind('UploadProgress', function(up, file) {
                $('#' + file.id + " .progress").fadeIn('fast');
                $('#' + file.id + " .progress .progress-bar").width(file.percent + "%");
            });

            uploader.bind('Error', function(up, err) {

                AjaxForms.form_submit_response("Message: " + err.message + (err.file ? ", File: " + err.file.name : "") ,'error');
                
                up.refresh();

            });

            uploader.bind('FileUploaded', function(up, file,ee) {
                $('#' + file.id).append('<div style="width:70px;height:70px;display:block;background:transparent url('+UPLOAD_URL  +'tmp/'+ USER_ID +'/'+file.name+') no-repeat 50% 50%;background-size: cover;position: absolute;top: 0;  right: 0;" ></div>');
                $('#' + file.id).append('<input type="hidden" name="file[]" value="'+'tmp/'+ USER_ID +'/'+file.name+'" />')
                $('#' + file.id + " .progress").fadeOut('fast');
            });
        })


    }
};